import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const MikadoClosed = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Temporarily Closed",
      subtitle: "Mikado Sushi is taking a break",
      message: "We invite you to visit our restaurant Roze",
      buttonText: "Go to Restaurant Roze"
    },
    lv: {
      title: "Īslaicīgi Slēgts",
      subtitle: "Mikado Sushi ir īslaicīgi slēgts",
      message: "Aicinām Jūs apmeklēt mūsu restorānu Roze",
      buttonText: "Doties uz Restorānu Roze"
    },
    ru: {
      title: "Временно Закрыто",
      subtitle: "Mikado Sushi временно не работает",
      message: "Приглашаем вас в наш ресторан Roze",
      buttonText: "Перейти в Ресторан Roze"
    }
  };

  const t = content[language] || content.lv;

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        {/* Logo */}
        <div className="mb-8">
          <div className="w-24 h-24 bg-white rounded-2xl flex items-center justify-center mx-auto mb-6">
            <span className="text-5xl">🍣</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">MIKADO</h1>
          <p className="text-gray-400 text-lg tracking-widest">SUSHI</p>
        </div>

        {/* Main Message */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t.title}
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            {t.subtitle}
          </p>

          {/* Divider */}
          <div className="w-16 h-1 bg-white/20 mx-auto mb-8"></div>

          {/* Restaurant Link */}
          <p className="text-gray-300 mb-6">{t.message}</p>
          <a
            href="https://restoransroze.lv"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-black font-bold px-8 py-4 rounded-full text-lg hover:bg-gray-100 transition-all duration-300 hover:scale-105 hover:shadow-2xl"
          >
            {t.buttonText}
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        </div>

        {/* Footer */}
        <p className="text-gray-500 text-sm">
          Liepu iela 9, Liepāja • +371 28717331
        </p>
      </div>
    </div>
  );
};

export default MikadoClosed;
